// extracted by mini-css-extract-plugin
export default {"createBox":"create-box_createBox__mWg58","active":"create-box_active__EpI4L","icon":"create-box_icon__EMrOA","createRow":"create-box_createRow__4npez"};